import axios from 'axios'

export default defineNuxtPlugin(async (nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()
  await nuxtApp.$i18n?.ready
  const selectedCountry = nuxtApp.$i18n.locale.value.toUpperCase()
  const selectedLanguage = useCookie('selected-language')

  const axiosInstance = axios.create({
    baseURL: runtimeConfig.public.API_URL,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      'Api-Origin': runtimeConfig.public.API_ORIGIN,
      Accept: 'application/json',
      'Country-Code': selectedCountry,
      'Lang-Code': selectedLanguage.value
    }
  })

  axiosInstance.interceptors.request.use(config => {
    if (selectedCountry) {
      config.headers['Country-Code'] = selectedCountry
    }
    if (selectedLanguage.value) {
      config.headers['Lang-Code'] = selectedLanguage.value
    }
    return config
  }, error => Promise.reject(error))

  nuxtApp.provide('axios', axiosInstance)
})
